import DetailsButton from './DetailsButtonContainer';

export default DetailsButton;
